"use client"

import { useAuth } from "@clerk/nextjs"
import {
  AUTHENTICATED_HOME_PATH,
  PUBLIC_LANDING_PATH,
} from "@/lib/routing/home"

export function useHomeHref(): {
  href: string
  label: string
  ready: boolean
} {
  const { isSignedIn, isLoaded } = useAuth()

  if (!isLoaded) {
    return { href: PUBLIC_LANDING_PATH, label: "Back", ready: false }
  }

  if (isSignedIn) {
    return {
      href: AUTHENTICATED_HOME_PATH,
      label: "Back to events",
      ready: true,
    }
  }

  return { href: PUBLIC_LANDING_PATH, label: "Back home", ready: true }
}
